import type { StripeSubscription } from "@arbeidsark/shared"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { useTranslate } from "~/ur-react-hooks"
import { format } from "~/utils/date-fns/format"

const Layout = styled.div`
  width: 100%;
  height: 2rem;
  left: 0;
  right: 0;
  top: 0;
  position: absolute;

  background: ${(props) => props.theme.colors.warning50};

  display: flex;
  justify-content: center;
  align-items: center;
`

const Text = styled.span`
  font-size: 0.875rem;
  color: ${(props) => props.theme.colors.warning99};
`

export interface DashboardSubscriptionExpiringBannerProps {
  subscription: StripeSubscription
}

const DashboardSubscriptionExpiringBanner: React.FC<
  DashboardSubscriptionExpiringBannerProps
> = ({ subscription }) => {
  const formattedDate = format(
    subscription.trialEnd ?? new Date(),
    "dd MMMM yyyy",
  )
  const translations = useTranslate({
    title: [
      "dashboard.subscription-expiring-banner.title",
      { date: formattedDate },
    ],
  })
  return (
    <Link to="/subscription/trial-pay">
      <Layout>
        <Text>{translations.title()}</Text>
      </Layout>
    </Link>
  )
}

export default DashboardSubscriptionExpiringBanner
